import React, { useState } from "react";
import styles from "./SignupV1.module.css"
import Form from 'react-bootstrap/Form';

export default function Signup({title, text, input, endpoint}) {

    //Title: the titel of the signin div
    //Text: The text in the input
    //input: a bool which allows the Textbox to apear 
    //endpoint: specifies the endponit the request should post to

    const [textInput, setTextInput] = useState("Ingen ønsker nævnt");
    const [email, setEmail] = useState("");
    const [validationMessage, setValidationMessage] = useState(""); // Add state for validation message
    const [resMessage, setResMessage] = useState("");
    const API_URL = process.env.NODE_ENV === "development" ? "http://localhost:3000/" : "https://api.hillerodfrimenighed.dk/";

    const handleSubmit = (e) => {
        e.preventDefault();
    if(endpoint === "/Kristendomskursus"){
        // Sends both the users email and text to the server
        fetch(`${API_URL}register${endpoint}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: email, input: textInput}),
        })
        .then((response) => response.json())
        .then((data) => {
            setResMessage(data.message);
        });
    
    } else if(endpoint === "/mail") {
        // Sends only the users email to the server
        fetch(`${API_URL}register${endpoint}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: email}),
        })
        .then((response) => response.json())
        .then((data) => {
            setResMessage(data.message);
        });
    }
    
  };

    return(
        <div className={styles.signupWrapper}>
            <div className={styles.signupBox}>
                <div className={styles.line}></div>
                <h1 className={styles.title}>{title}</h1>
                <p className={styles.description} dangerouslySetInnerHTML={{ __html: text }}/>
                <Form onSubmit={handleSubmit} className={styles.form}>
                {input && 
                    // beskrivelse
                    <Form.Group className={styles.descriptionInput} controlId="exampleForm.ControlTextarea1">
                        <Form.Control 
                            className={styles.input}
                            as="textarea" 
                            rows={3} 
                            placeholder="Skriv dine ønsker her" 
                            onChange={(e) => setTextInput(e.target.value)}/>
                    </Form.Group>
                }
                {/* email felt */}
                <Form.Group className={styles.mailInput} controlId="formBasicEmail">
                    <Form.Control
                        className={styles.input}
                        type="email"
                        placeholder="Skriv din email her"
                        onChange={(e) => {
                            setEmail(e.target.value);
                            setValidationMessage("");
                            setResMessage("");
                            }}
                        onInvalid={(e) => {
                        e.preventDefault();
                        setResMessage("");
                        setEmail("")
                        setValidationMessage('Venligst indtast en gyldig email'); // Set validation message
                        }}
                        required
                    />
                {/* Render validation message if it's not empty */}
                {validationMessage && <div className={styles.validationMessage}>{validationMessage}</div>}
                {resMessage && <div className={styles.validationMessage}>{resMessage}</div>} {/* displays the response from the server */}
                </Form.Group>
                <button type="submit" className={styles.submit}>Tilmeld</button>
                </Form>
            </div>
        </div>
    );
}